export default "__VITE_ASSET__CJYnb8kp__"